import React from "react";

export default function Delete(props){
    const styling = {
        backgroundColor : props.backgroundColor,
        boxShadow : props.shadowColor
    }
    return <div id = "delete" onClick = {props.clicked} style = {styling}>DEL</div>
}